module.exports = __webpack_public_path__ + "img/eye.ab46397b.svg";